import { render, staticRenderFns } from "./MessageCardWithoutFml.vue?vue&type=template&id=142a537c&scoped=true&"
import script from "./MessageCardWithoutFml.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MessageCardWithoutFml.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MessageCardWithoutFml.vue?vue&type=style&index=0&id=142a537c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142a537c",
  null
  
)

export default component.exports